import React from 'react'
import PropTypes from 'prop-types'
import IconButton from 'material-ui/IconButton'
import CircularProgress from 'material-ui/CircularProgress'
import FileDownload from 'material-ui/svg-icons/file/file-download'
import { ITEM_STATUS } from '../../constants'
import withFileExport from '../withFileExport'

const DownloadItemInvoice = ({ isExporting, item, requestExport }) => {
  const handleExport = () => {
    const path = `admin/order_items/${item.id}/invoice/export`
    return requestExport(path)
  }

  const isUnfulfilled = item.item_status !== ITEM_STATUS.FULFILLED
  const isDisabled = isUnfulfilled || isExporting
  return (
    <div>
      <IconButton disabled={isDisabled} onClick={handleExport}>
        {isExporting ? (
          <CircularProgress color='#000000' mode='indeterminate' size={20} />
        ) : (
          <FileDownload />
        )}
      </IconButton>
    </div>
  )
}

export default withFileExport(DownloadItemInvoice)

// @ts-ignore
DownloadItemInvoice.propTypes = {
  isExporting: PropTypes.bool.isRequired,
  item: PropTypes.shape({
    id: PropTypes.number.isRequired,
    item_status: PropTypes.oneOf(Object.values(ITEM_STATUS))
  }).isRequired,
  requestExport: PropTypes.func.isRequired
}
